import React from 'react'
import { Document, Font, Image, Page } from '@react-pdf/renderer'
import { renderToStaticMarkup } from 'react-dom/server'
import Html from 'react-pdf-html'
import CCLogo from '../../../Images/Branding/cc-combination-blue.png'
import { ProgramDirectoryReportRow } from '../../../swagger'
import ProgramDirectoryPDF from './ProgramDirectoryPDF'
import { styles } from './styles'

/** react-pdf only breaks lines at spaces and never inside unbroken tokens such
 * as emails, phone numbers, or dates. Short words are left whole so the line
 * breaker wraps them at full-word boundaries (never "Foundation-s"). Only
 * tokens longer than the widest realistic column value (e.g. long emails) are
 * given break opportunities as a last resort, emulating word-break: break-word
 */
Font.registerHyphenationCallback((word) => {
  if (word.length <= 14) {
    return [word]
  }
  return word.match(/.{1,3}/g) ?? [word]
})

const ProgramDirectoryReportPDF: React.FC<{
  rows: ProgramDirectoryReportRow[]
  communityName?: string
}> = ({ rows, communityName }) => {
  return (
    <Document title="Program Directory">
      <Page size="LETTER" style={styles.page} orientation="landscape">
        <Image style={styles.logo} src={CCLogo} />
        <Html>
          {renderToStaticMarkup(
            <ProgramDirectoryPDF rows={rows} communityName={communityName} />
          )}
        </Html>
      </Page>
    </Document>
  )
}

export default ProgramDirectoryReportPDF
